import {useTranslation} from 'react-i18next';

import {Grid} from '@mui/material';

import {WorkforceProfileWizardMetadataFields} from '../WorkforceProfileWizard/WorkforceProfileWizardMetadataFields';

import {DragAndDropDocumentUpload} from '../../../../../components/DragAndDropDocumentUpload/DragAndDropDocumentUpload';
import {InfoBanner} from '../../../../../components/InfoBanner/InfoBanner';
import {SupportedLanguages} from '../../../../../types/SupportedLanguages';
import {Department} from '../../../profile/types';
import {DepartmentTargetProfileAssignment} from '../../types/DepartmentTargetProfileTypes';
import type {WorkforceProfileResearchLookup, WorkforceProfileWizardSetup} from '../../types/workforceProfileWizardTypes';

export interface Props {
  departments: Department[];
  currentLanguage: SupportedLanguages;
  setup: WorkforceProfileWizardSetup;
  lookup: WorkforceProfileResearchLookup;
  departmentTargetProfiles: DepartmentTargetProfileAssignment[];
  isTargetProfilesLoading: boolean;
  isTargetProfilesError: boolean;
  profileFile: File | null;
  onSetupChange: (setup: WorkforceProfileWizardSetup) => void;
  onLookupChange: (lookup: WorkforceProfileResearchLookup) => void;
  onProfileFileChange: (file: File | null) => void;
}

export const WorkforceProfileDocumentUploadBranch = ({
  departments,
  currentLanguage,
  setup,
  lookup,
  departmentTargetProfiles,
  isTargetProfilesLoading,
  isTargetProfilesError,
  profileFile,
  onSetupChange,
  onLookupChange,
  onProfileFileChange,
}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.createModal'});

  return (
    <Grid container spacing={2} sx={{mt: 1}}>
      <Grid item xs={12}>
        <WorkforceProfileWizardMetadataFields
          departments={departments}
          currentLanguage={currentLanguage}
          setup={setup}
          lookup={lookup}
          departmentTargetProfiles={departmentTargetProfiles}
          isTargetProfilesLoading={isTargetProfilesLoading}
          isTargetProfilesError={isTargetProfilesError}
          onSetupChange={onSetupChange}
          onLookupChange={onLookupChange}
        />
      </Grid>
      <Grid item xs={12}>
        <InfoBanner text={String(t('subtitle'))} />
      </Grid>
      <Grid item xs={12}>
        <DragAndDropDocumentUpload value={profileFile} onChange={onProfileFileChange} />
      </Grid>
    </Grid>
  );
};
